import { useEffect, useState } from 'react';

export const useReprofilingState = (initialSuggestion?: string, initialOccupationSuggestion?: string) => {
  const [suggestion, setSuggestion] = useState<string | undefined>(undefined);
  const [selection, setSelection] = useState<string | undefined>(undefined);

  const [occupationSuggestion, setOccupationSuggestion] = useState<string | undefined>(undefined);
  const [occupationSelection, setOccupationSelection] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (initialSuggestion && !suggestion) {
      setSuggestion(initialSuggestion);
      setSelection(initialSuggestion);
    }
  }, [initialSuggestion, suggestion]);

  useEffect(() => {
    if (initialOccupationSuggestion && !occupationSuggestion) {
      setOccupationSuggestion(initialOccupationSuggestion);
      setOccupationSelection(initialOccupationSuggestion);
    }
  });

  const handleSelectionChange = (newSelection: string) => {
    setSelection(newSelection);
  };

  const handleOccupationSelectionChange = (newOccupationSelection: string) => {
    setOccupationSelection(newOccupationSelection);
  };

  return {
    suggestion,
    selection,
    occupationSuggestion,
    occupationSelection,
    onSelectionChange: handleSelectionChange,
    onOccupationSelectionChange: handleOccupationSelectionChange,
  };
};
